<div [ngClass]="customClass || ''" class="modal" [ngStyle]="{display: show ? 'block' : 'none'}">
    <div class="overlay" (click)="closeCallback()"></div>
    <div class="modal_content">
        <ng-content></ng-content>
        <div id="right-hand-menu-icon" class="close">
            <a class="close-icon" (click)="closeCallback()">
                &times;
            </a>
        </div>
    </div>
</div>
